/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

import { AdminReserveSurveyMarksBody } from '../../models/admin-reserve-survey-marks-body';

export interface AdminReserveSurveyMarks$Params {
  body: AdminReserveSurveyMarksBody;
}

export function adminReserveSurveyMarks(
  http: HttpClient,
  rootUrl: string,
  params: AdminReserveSurveyMarks$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, adminReserveSurveyMarks.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http
    .request(rb.build({ responseType: 'text', accept: '*/*', context }))
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({
          body: undefined,
        }) as StrictHttpResponse<void>;
      }),
    );
}

adminReserveSurveyMarks.PATH = '/admin/surveyMarks/reserved';
